import { TIME_RANGE } from '~services/constant/common';

// 图表统计时间下拉框
export const CHART_TOTAL_TIME_OPTIONS = [
  {
    label: '今天',
    value: TIME_RANGE.today,
  },
  {
    label: '昨天',
    value: TIME_RANGE.yesterday,
  },
  {
    label: '本周',
    value: TIME_RANGE['this-week'],
  },
  {
    label: '上周',
    value: TIME_RANGE['last-week'],
  },
  {
    label: '本月',
    value: TIME_RANGE['this-month'],
  },
  {
    label: '上月',
    value: TIME_RANGE['last-month'],
  },
  {
    label: '本季度',
    value: TIME_RANGE['this-quarter'],
  },
  {
    label: '上一季度',
    value: TIME_RANGE['last-quarter'],
  },
  {
    label: '本年度',
    value: TIME_RANGE['this-year'],
  },
  {
    label: '上一年度',
    value: TIME_RANGE['last-year'],
  },
  {
    label: '自定义时间',
    value: TIME_RANGE['self-time'],
  },
];

// 搜索输入框数据内容所属类型
const timingSearchInputTypes = ['用户账号', '用户名称'];
export const TIMING_SEARCH_INPUT_OPTIONS = timingSearchInputTypes.map((label, index) => ({
  label,
  value: index + 1,
}));

//  拜访记录用户角色搜索下拉框
const visitSearchSelectTypes = ['销售人员', '非销售人员'];

export const VISIT_SEARCH_SELECT_OPTIONS = visitSearchSelectTypes.map((label, index) => ({
  label,
  value: index + 1,
}));
